import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QuizzesState } from '../reducers/quizzes.reducer';
import { QUIZZES_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<QuizzesState>(QUIZZES_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state: QuizzesState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: QuizzesState) => state.loading);
export const selectQuizzes = createSelector(selectState, (state: QuizzesState) => state.quizzes);
export const selectTotal = createSelector(selectState, (state: QuizzesState) => state.total);
export const selectPage = createSelector(selectState, (state: QuizzesState) => state.page);
export const selectLimit = createSelector(selectState, (state: QuizzesState) => state.limit);
export const selectLastParams = createSelector(selectState, (state: QuizzesState) => state.lastParams);
